import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { AppState } from 'Features/App/store';
import { StationType } from 'Services/api/v2';
import { SelectedMapFilter } from './utilts';

type MapSliceState = {
  zoom: number
  selectedStation: StationType | null
  isShowGeoJSON: boolean
  isEnableClustering: boolean
  selectedMapFilter: SelectedMapFilter,
  mapMeteocodeData: any[],
}

export const MAP_SLICE = 'map';

const initialState: MapSliceState = {
  isShowGeoJSON: false,
  zoom: 4,
  selectedStation: null,
  isEnableClustering: true,
  selectedMapFilter: 'MODE',
  mapMeteocodeData: [],
};

const mapSlice = createSlice({
  name: MAP_SLICE,
  initialState,
  reducers: {
    resetSelectedStation: (state) => Object.assign(state, { selectedStation: null }),
    selectStationAndCenterZoom: (state, { payload }: PayloadAction<MapSliceState['selectedStation']>) => {
      Object.assign(state, {
        zoom: 9,
        selectedStation: payload,
      });
    },
    setSelectedMapFilter: (state, { payload }: PayloadAction<MapSliceState['selectedMapFilter']>) => {
      state.selectedMapFilter = payload;
      state.mapMeteocodeData = [];
    },
    toggleShowGeoJSON: (state) => {
      state.isShowGeoJSON = !state.isShowGeoJSON;
    },
    toogleClastering: (state) => {
      state.isEnableClustering = !state.isEnableClustering;
    },
    setMapMeteocodeData: (state, { payload }: PayloadAction<MapSliceState['mapMeteocodeData']>) => {
      state.mapMeteocodeData = payload;
    },
  },
});

export default mapSlice.reducer;

export const {
  resetSelectedStation,
  selectStationAndCenterZoom,
  toggleShowGeoJSON,
  toogleClastering,
  setSelectedMapFilter,
  setMapMeteocodeData,
} = mapSlice.actions;

export const isShowGeoJSONSelector = (state: AppState) => state.map.isShowGeoJSON;
export const selectedStationSelector = (state: AppState) => state.map.selectedStation;
export const isEnableClusteringSelector = (state: AppState) => state.map.isEnableClustering;
export const selectedMapFilterSelector = (state: AppState) => state.map.selectedMapFilter;
export const mapMeteocodeDataSelector = (state: AppState) => state.map.mapMeteocodeData;
